export const Popover = theme => ({
  styleOverrides: {
    paper: {
      borderRadius: 12,
      boxShadow: theme.shadows[2]
    }
  }
});